import { useState, useEffect } from 'react'

export const useFetchAllClients = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [clients, setClients] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllClients, setLoadingFetchAllClients ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllClients = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/clients`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllClients(true)
        fetchData()
            .then((resp) => {
                setClients(resp.data)
                setLoadingFetchAllClients(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllClients(false)
            })
    }, [execute])

    return { clients, loadingFetchAllClients, executeFetchAllClients }

}

export const useFetchInfoClient = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormClients } = Forms
    const { formState, setFormState } = FormClients
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoClient, setLoadingFetchInfoClient ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoClient = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/clients/${paramsToSearch.idcliente}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcliente > 0 ){
            setLoadingFetchInfoClient(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idcliente: data.idcliente || '',
                        nombre: data.nombre || '',
                        apellido: data.apellido || '',
                        apellido_casado: data.apellido_casado || '',
                        direccion_dpi: data.direccion_dpi || '',
                        nit: data.nit || '',
                        profesion: data.profesion || '',
                        estado_civil: data.estado_civil || '',
                        nacionalidad: data.nacionalidad || '',
                        calle: data.calle || '',
                        sector: data.sector || '',
                        lote: data.lote || '',
                        seccion: data.seccion || '',
                        manzana: data.manzana || '',
                        colonia: data.colonia || '',
                        codigo_ingreso: data.codigo_ingreso || '',
                        zona: data.zona || '',
                        municipio: data.municipio || '',
                        departamento: data.departamento || '',
                        referencia: data.referencia || '',
                        direccion_2: data.direccion_2 || '',
                        telefono: data.telefono || '',
                        dpi: data.dpi || '',
                        celular_1: data.celular_1 || '',
                        celular_2: data.celular_2 || '',
                        telefono_casa: data.telefono_casa || '',
                        telefono_trabajo: data.telefono_trabajo || '',
                        extension: data.extension || '',
                        correo: data.correo || '',
                        nombres_familiar_1: data.nombres_familiar_1 || '',
                        parentesco_familiar_1: data.parentesco_familiar_1 || '',
                        contacto_familiar_1: data.contacto_familiar_1 || '',
                        nombres_familiar_2: data.nombres_familiar_2 || '',
                        parentesco_familiar_2: data.parentesco_familiar_2 || '',
                        contacto_familiar_2: data.contacto_familiar_2 || '',
                        nombres_familiar_3: data.nombres_familiar_3 || '',
                        parentesco_familiar_3: data.parentesco_familiar_3 || '',
                        contacto_familiar_3: data.contacto_familiar_3 || '',
                        nombres_personal_1: data.nombres_personal_1 || '',
                        parentesco_personal_1: data.parentesco_personal_1 || '',
                        contacto_personal_1: data.contacto_personal_1 || '',
                        nombres_personal_2: data.nombres_personal_2 || '',
                        parentesco_personal_2: data.parentesco_personal_2 || '',
                        contacto_personal_2: data.contacto_personal_2 || '',
                        nombres_personal_3: data.nombres_personal_3 || '',
                        parentesco_personal_3: data.parentesco_personal_3 || '',
                        contacto_personal_3: data.contacto_personal_3 || '',


                    }))
                    setLoadingFetchInfoClient(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoClient(false)
                })
        }
    }, [execute])

    return { loadingFetchInfoClient, setParamsToSearch, executeFetchInfoClient }

}